<template>
  <div class="row">
    <!-- Big Chart -->
    <div class="col-12">
  
      <card type="chart">
           
        <template slot="header">
      
          <div class="row">
           
            <div class="col-sm-6" :class="isRTL ? 'text-right' : 'text-left'">
              <h5 class="card-category">Total</h5>
              <h2 class="card-title">Energy Comsumption</h2>
            </div>
            <div class="col-sm-6 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in bigLineChartCategories"
                  :key="option.name"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: bigLineChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="initBigChart(index)"
                    name="options"
                    autocomplete="off"
                    :checked="bigLineChart.activeIndex === index"
                  />
                  <span class="d-none d-sm-block">{{ option.name }}</span>
                  <span class="d-block d-sm-none">
                    <i :class="option.icon"></i>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :gradient-colors="bigLineChart.gradientColors"
            :gradient-stops="bigLineChart.gradientStops"
            :extra-options="bigLineChart.extraOptions"
            :key="componentKey"
          >
          </line-chart>
        </div>
      </card>
    </div>
    <!-- Stats Cards -->
    <div class="col-lg-3 col-md-6" v-for="card in statsCards" :key="card.title">
      <stats-card
        :title="card.title"
        :sub-title="card.subTitle"
        :type="card.type"
        :icon="card.icon"
      >
        <div slot="footer" v-html="card.footer"></div>
      </stats-card>
    </div>

    <!-- Small charts -->
    <!-- <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Total Shipments</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-bell-55 text-primary "></i> 763,215
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="purpleLineChart.chartData"
            :gradient-colors="purpleLineChart.gradientColors"
            :gradient-stops="purpleLineChart.gradientStops"
            :extra-options="purpleLineChart.extraOptions"
          >
          </line-chart>
        </div>
      </card>
    </div> -->
    <!-- <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Daily Sales</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-delivery-fast text-info "></i> 
            3,500€
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            style="height: 100%"
            :chart-data="blueBarChart.chartData"
            :gradient-stops="blueBarChart.gradientStops"
            :extra-options="blueBarChart.extraOptions"
          >
          </bar-chart>
        </div>
      </card>
    </div> -->
    <!-- <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Completed tasks</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-send text-success "></i> 12,100K
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="greenLineChart.chartData"
            :gradient-stops="greenLineChart.gradientStops"
            :extra-options="greenLineChart.extraOptions"
          >
          </line-chart>
        </div>
      </card>
    </div> -->
    <div class="col-lg-5">
      <card type="tasks" :header-classes="{ 'text-right': isRTL }">
        <template slot="header">
          <h6 class="title d-inline">latest posts</h6>
          <!-- <p class="card-category d-inline">Today</p> -->
          <!-- <base-dropdown
            menu-on-right=""
            tag="div"
            title-classes="btn btn-link btn-icon"
            :class="{ 'float-left': isRTL }"
          >
            <i slot="title" class="tim-icons icon-settings-gear-63"></i>
            <a class="dropdown-item" href="#pablo"> Action </a>
            <a class="dropdown-item" href="#pablo"> Another action </a>
            <a class="dropdown-item" href="#pablo"> Something else </a>
          </base-dropdown> -->
        </template>
        <div class="table-full-width table-responsive">
          <task-list></task-list>
        </div>
      </card>
    </div>

       <div class="col-lg-7">
      <card class="card" :header-classes="{ 'text-right': isRTL }">
        <h5 slot="header" class="card-title">Top 6 energy savers<router-link to="/rank"><h5 class="col-md-3 ml-auto
">see all</h5></router-link></h5>


        
        <div class="table-responsive">
          <user-table></user-table>
          </div>
      </card>
    </div>

 
      <div class="col-lg-3 col-md-6">
        <card
          type="pricing"
          class="card-primary"
          footer-classes="text-center mb-3 mt-3"
        >
          <h4 class="card-title">#1</h4>
          <img class="card-img" src="img/card-primary.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Medium plan sdm,asdansd,m asndansd,amsnd,mans</li>
            <li class="list-group-item">130 emails</li>
          </ul>
          <div class="card-prices">
           
          </div>
          <base-button
          @click="ModalVisible1 = true"
           slot="footer" 
           round type="primary" class="btn-just-icon">
            Get started
          </base-button>

          
        </card>
      </div>

       <modal
        :show.sync="ModalVisible1"
        class="modal-search"
        id="searchModal1"
        :centered="false"
        :show-close="true"
      >
       

        <div><section>
          <iframe width="600" height="400" src="https://www.youtube.com/embed/IQw-4JABPCM?controls=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></section></div>
         
        <base-button class="animation-on-hover" 
          type="success"
                       
        >Post</base-button>
       
      </modal>



      

      <div class="col-lg-3 col-md-6">
        <card
          type="pricing"
          class="card-success card-white"
          footer-classes="text-center mb-3 mt-3"
        >
          <h4 class="card-title">#2</h4>
          <img class="card-img" src="img/card-success.png" alt="Image" />
          <ul class="list-group">
          <li class="list-group-item">Medium plan sdm,asdansd,m asndansd,amsnd,mans</li>
            <li class="list-group-item">130 emails</li>
          </ul>
          <div class="card-prices">
            <!-- <h3 class="text-on-front"><span>$</span>57</h3>
            <h5 class="text-on-back">57</h5>
            <p class="plan">Basic plan</p> -->
          </div>

          <base-button slot="footer" round type="success" class="btn-just-icon">
            Get started
          </base-button>
        </card>
      </div>

      <div class="col-lg-3 col-md-6">
        <card
          type="pricing"
          class="card-success card-white"
          footer-classes="text-center mb-3 mt-3"
        >
          <h4 class="card-title" ><span>#3</span ></h4>
          <img class="card-img" src="img/card-warning.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Medium plan sdm,asdansd,m asndansd,amsnd,mans</li>
            <li class="list-group-item">130 emails</li>
             <!--<li class="list-group-item">24/7 Support</li> -->
          </ul>
          <div class="card-prices">
            <!-- <h3 class="text-on-front"><span>1</span>1</h3> -->
           <!--  <h5 class="text-on-back">72</h5> -->
            <!-- <p class="plan">dsdsd</p> -->
          </div>

          <base-button slot="footer" round type="warning" class="btn-just-icon">
            Get started
          </base-button>
        </card>
      </div>
      <div class="col-lg-3 col-md-6">
        <card
          type="pricing"
          class="card-danger card-white"
          footer-classes="text-center mb-3 mt-3"
        >
          <h4 class="card-title">#4</h4>
          <img class="card-img" src="img/card-danger.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Medium plan sdm,asdansd,m asndansd,amsnd,mans</li>
            <li class="list-group-item">130 emails</li>
            <!-- <li class="list-group-item">No Support</li> -->
          </ul>
          <div class="card-prices">
            <!-- <h3 class="text-on-front"><span>$</span>9</h3>
            <h5 class="text-on-back">9</h5>
            <p class="plan">Trial plan</p> -->
          </div>

          <base-button slot="footer" round type="danger" class="btn-just-icon">
            Get started
          </base-button>
        </card>
      </div>
   
     <div class="col-md-12 mt-5"><h3 class="title">learn more</h3></div>
     
    <!-- <div class="col-lg-12"><country-map-card></country-map-card></div> -->
  </div>
  
</template>
<script>
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';
import * as chartConfigs from '@/components/Charts/config';
import TaskList from './TaskList';
import UserTable from './UserTable';
import CountryMapCard from './CountryMapCard';
import StatsCard from 'src/components/Cards/StatsCard';
import config from '@/config';
import firebase from '../../Firebase';
import moment from 'moment';
import swal from 'sweetalert2';
import { Modal } from '@/components';



var bigChartData = [
  [0,0,0,0,0,0,0,0,0,0,0,0],
  ]
let bigChartLabels = [['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],["SUN","MON", "TUE", "WED", "THR", "FRI", "SAT"]]
let bigChartDatasetOptions = {
  fill: true,
  borderColor: config.colors.primary,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.primary,
  pointBorderColor: 'rgba(255,255,255,0)',
  pointHoverBackgroundColor: config.colors.primary,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
}

export default {
  components: {
    LineChart,
    BarChart,
    StatsCard,
    TaskList,
    CountryMapCard,
    UserTable,
     Modal,
  },
  data() {
    return {
     ModalVisible1:false,
       activeNotifications: false,
       saved:"",
      info:"",
      meter:"",
    componentKey: 0,
      bigChartData1:[[]],
      id:0,
      monthint:0,
     energyf:{},
     energy:{},
      datalabels:["KWh","Wh"],
     datatest:[0.0,0.0,0.0,0.0,0.0,0.0,0.0],
      statsCards: [
        {
          title: '0.00',
          subTitle: 'Cost $',
          type: 'warning',
          icon: 'tim-icons icon-bank',
          footer: '<i class="tim-icons icon-money-coins"></i> fixed rate',
          route:''
        },
        {
          title: '0.00',
          subTitle: 'Energy KWh',
          type: 'primary',
          icon: 'tim-icons icon-bulb-63',
          footer: '<i class="tim-icons icon-sound-wave"></i></i> current month',
          route:''
        },
        {
          title: '0.00',
          subTitle: 'Savings $',
          type: 'info',
          icon: 'tim-icons icon-coins',
          footer: '<i class="tim-icons icon-trophy"></i> check the rank',
          route:'/rank'
        },
        {
          title: '1',
          subTitle: 'Meters',
          type: 'danger',
          icon: 'tim-icons icon-molecule-40',
          footer: '<i class="tim-icons icon-map-big"></i> Free plan - Upgrade to add more ',
          route:''
        }
      ],
      bigLineChart: {
        activeIndex: 10,
        chartData: {
          datasets: [{
          ...bigChartDatasetOptions,
            data: bigChartData[0]
          }],
          labels: bigChartLabels[0]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: []
      },
      purpleLineChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          datasets: [
            {
              label: 'Data',
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80]
            }
          ]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0]
      },
      greenLineChart: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV'],
          datasets: [
            {
              label: 'My First dataset',
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80]
            }
          ]
        },
        gradientColors: [
          'rgba(66,134,121,0.15)',
          'rgba(66,134,121,0.0)',
          'rgba(66,134,121,0)'
        ],
        gradientStops: [1, 0.4, 0]
      },
      blueBarChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ['USA', 'GER', 'AUS', 'UK', 'RO', 'BR'],
          datasets: [
            {
              label: 'Countries',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [53, 20, 10, 80, 100, 45]
            }
          ]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0]
      }
    };
  },
  async created() {


    const currentUser = firebase.auth().currentUser
  
//console.log(currentUser.uid)

    var currentTime = new Date();
    var dayweek = currentTime.getDay();
  //  console.log(dayweek);
  //  console.log(moment().subtract(dayweek,'days').startOf('day').unix())
  //  console.log(moment().startOf('month').unix())
  //     console.log(moment().endOf('month').unix())
  //      console.log(currentTime.getMonth())

   // this.bigLineChart.datasets[0].dat.push(0);

   firebase.database().ref('users').child(currentUser.uid).on('value',saved =>{

     
  this.statsCards[2].title=this.formatPrice(saved.child("saved").val());

})


    this.bigChartData1[0] = [0,0,0,0,0,0,0,0,0,0,0,0];


        let meter =  await firebase.database()
    .ref('location').child(currentUser.uid)
    //.ref('manual').child("test")
    .orderByChild('timestamp').limitToFirst(1).once("value");

     meter.forEach(info => {

this.meter = info.child("loc").val()
  
  console.log("dash meter: "+info.child("loc").val())
      });

    for (let index = currentTime.getMonth(); index > -1; index--) {
      
 let currentmonth = new Date(moment().subtract(index,'months').startOf('month').unix()*1000);
  this.bigChartData1[0][currentmonth.getMonth()]= await this.getmonthhere(index);


//  firebase.database()
//    // .ref('manual').child("newmeter")
//  .ref('smeter').child(this.meter).child("0_total")
//  .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
//     .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToFirst(1).once("value", notes => {
//       notes.forEach(init => {
// //console.log("day 1 date:"+init.child("timestamp").val()+"//"+init.child("0_total").val());

//  firebase.database()
//  //.ref('manual').child("newmeter")
//  .ref('smeter').child(this.meter).child("0_total")
// .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
// .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToLast(1).once("value", notes => {
//       notes.forEach(final => {
// //console.log("day 2 date:"+final.child("timestamp").val()+"//"+final.child("0_total").val());
//  let energytotal = ((final.child("0_total").val()-init.child("0_total").val())/1000).toFixed(2);

//   this.bigChartData1[0][currentmonth.getMonth()]= energytotal;
//       })
//     });
//       })
//     }); 

    }

//     firebase.database()
//     //.ref('manual').child("newmeter")
//     .ref('smeter').child(this.meter).child("0_total")
//     .orderByChild('timestamp').startAt(moment().startOf('month').unix()* 1000-300000)
//     .endAt(moment().endOf('month').unix()*1000).limitToFirst(1).once("value", notes => {
//       notes.forEach(note => {
// //console.log("day 1 date:"+note.child("timestamp").val()+"//"+note.child("0_total").val());

// this.monthint = note.child("0_total").val();
//  firebase.database()
//  //.ref('manual').child("newmeter")
//  .ref('smeter').child(this.meter).child("0_total")
// .orderByChild('timestamp').startAt(moment().startOf('month').unix()* 1000-300000)
// .endAt(moment().endOf('month').unix()*1000).limitToLast(1).once("value", notes => {
//       notes.forEach(note => {
// //console.log("day 2 date:"+note.child("timestamp").val()+"//"+note.child("0_total").val());
//  let energytotal = ((note.child("0_total").val()-this.monthint)/1000).toFixed(2);

//   this.bigChartData1[0][currentTime.getMonth()]= energytotal;

//   this.statsCards[0].title = (energytotal*.17).toFixed(2);
//     this.statsCards[1].title = energytotal;
// this.forceRerender();
//       })
//     });


//       })
//     });
    

     
    firebase.database()
   // .ref('manual').child("newmeter")
    .ref('smeter').child(this.meter).child("0_total")
    .orderByChild('timestamp')
    .startAt(moment().subtract(dayweek,'days')
    .startOf('day').unix()* 1000-300000).once("value", notes => {
      notes.forEach(note => {
        



        var Time = new Date(note.child("timestamp").val());

//console.log("date"+Time.getDay()+"//"+note.child("0_total").val());
if(Time.getDay()===this.day){
        this.energyf =note.child("0_total").val();
      let subtotal= this.energyf-this.energy;
      let subtotla1=  this.datatest[Time.getDay()];
      let total = subtotal+subtotla1;
    //  console.log("totla: "+total);

        this.datatest[Time.getDay()]= total;
        this.energy = note.child("0_total").val();

      }else{

          if (this.id!==0){

this.datatest[Time.getDay()]= note.child("0_total").val()-this.energy;
this.energy = note.child("0_total").val();
          }
          else{
this.energy = note.child("0_total").val();

          }
          this.id++;
          this.day=Time.getDay();         
        }

      });
   //   this.forceRerender();
console.log("----");
//this.data.filter(function(value, index, arr){ return value.energy > 0;});
this.id=0;
this.datatest.forEach(ener => {

  this.datatest[this.id] = parseFloat(ener).toFixed(2);
  this.id++;
//console.log(ener);


});

this.bigChartData1.push(this.datatest);




    });




   },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    bigLineChartCategories() {
      return [{ name: 'Monthly', icon: 'tim-icons icon-minimal-left' }, { name: 'Weekly', icon: 'tim-icons icon-minimal-right' }];
    }
  },
  methods: {
   async getmonthhere(index){
// console.log(index)
//   console.log(moment().subtract(index,'months').startOf('month'))
     let vinit=0,vlast=0,vinit1=0,vlast1=0;

 let init = await firebase.database()
   // .ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("0_total")
 .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
    .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToFirst(1).once("value");
      
      init.forEach(init1 => {
vinit = init1.child("0_total").val()
      });
   
    //  init[0].child("0_total").val();


 let last = await  firebase.database()
 //.ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("0_total")
.orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
.endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToLast(1).once("value");
   last.forEach(init1 => {
vlast = init1.child("0_total").val()
      });

 let energytotal = ((vlast-vinit)/1000).toFixed(2);

//////***** */
 let init1 = await firebase.database()
   // .ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("1_total")
 .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
    .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToFirst(1).once("value");
      
      init1.forEach(init11 => {
vinit1 = init11.child("1_total").val()

      });
   
  let last1 = await  firebase.database()
 //.ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("1_total")
.orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
.endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToLast(1).once("value");
   last1.forEach(init11 => {
vlast1 = init11.child("1_total").val()
      });
 let energytotal1 = ((vlast1-vinit1)/1000).toFixed(2);

let finaltotal =  parseFloat(energytotal)+parseFloat(energytotal1);
if(index===0){
  this.statsCards[0].title = (finaltotal*.17).toFixed(2);
    this.statsCards[1].title = finaltotal.toFixed(2);
  this.forceRerender();
}
 
       return finaltotal.toFixed(2);
     
    },

     VaySwal(type) {
        console.log(type);
     },
     showSwal(type) {
        swal.fire({
          title: 'Input something',
          html: `<div class="form-group">
            <input v-model="info" id="info" type="text" class="form-control" />
            </div>
             <b-button @click.native="VaySwal('measure')" variant="primary">Save</b-button>
            `,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          buttonsStyling: false
        })
          .then(() => {
            swal.fire({
              icon: 'success',
              html: 'You entered '+this.info,
              customClass: {
                confirmButton: 'btn btn-success btn-fill'
              },
              buttonsStyling: false
            });
          })
          .catch(swal.noop);
     },
     formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    forceRerender() {
      console.log(" render ");
      this.componentKey += 1;
    },
    initBigChart(index) {

   
let chartData = {
        datasets: [{
          ...bigChartDatasetOptions,
          
          data: this.bigChartData1[index]
        }],
        labels: bigChartLabels[index]
      };
     
      
      this.$refs.bigChart.updateGradients(chartData);
      this.bigLineChart.chartData = chartData;
     //  this.bigLineChart.extraOptions = chartConfigs.purpleChartOptions;
      this.bigLineChart.activeIndex = index;
    }
  },
  mounted() {
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = 'ar';
      this.$rtl.enableRTL();
    }
    this.initBigChart(0);
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = 'en';
      this.$rtl.disableRTL();
    }
  }
};
</script>
<style></style>
